import { declineWord } from '@/modules/common/helpers/decline-word.helper';
import styles from './index.module.sass';
import { warehouseModel } from '@/entities/warehouse';
import { $selectedRecipeStore } from '@/modules/mixing/store/recipes.store';
import { WarehouseTypes } from '@/modules/warehouses/ts';
import { useStore } from 'effector-react';

export const DataCardBadge = ({ data, weight, id, title, price }: IDataCardBadge) => {
  const activeWarehouse = useStore($selectedRecipeStore);
  const isWarehouseTypeSleeve =
    activeWarehouse?.type &&
    (Number(activeWarehouse.type) as unknown as WarehouseTypes) ===
      warehouseModel.WAREHOUSE_TYPES.sleeve;
  return (
    <div className={styles.root}>
      <div className={styles.topData}>
        <span>
          {isWarehouseTypeSleeve
            ? declineWord(Number(+id), ['рукавов', 'рукав', 'рукава'])
            : declineWord(Number(+id), ['объёмов', 'объём', 'объёма'])}
        </span>
        <div className={styles.weight}>
          вес
          <div className={styles.weightBadge}>{Number(weight)?.toFixed(1)} т</div>
        </div>
      </div>
      <div className={styles.midData}>
        <div className={styles.spec}>
          <span className={styles.specName}>клейковина</span>
          <span className={styles.specVal}>{data.gluten}</span>
          <span className={styles.specSign}>%</span>
        </div>
        <div className={styles.spec}>
          <span className={styles.specName}>влажность</span>
          <span className={styles.specVal}>{data.humidity}</span>
          <span className={styles.specSign}>%</span>
        </div>
        <div className={styles.spec}>
          <span className={styles.specName}>ИДК</span>
          <span className={styles.specVal}>{data.idk}</span>
        </div>
        <div className={styles.spec}>
          <span className={styles.specName}>число падения</span>
          <span className={styles.specVal}>{data.cp}</span>
          <span className={styles.specSign}>сек</span>
        </div>
        <div className={styles.spec}>
          <span className={styles.specName}>протеин</span>
          <span className={styles.specVal}>{data.protein}</span>
          <span className={styles.specSign}>кДа</span>
        </div>
        <div className={styles.spec}>
          <span className={styles.specName}>натура</span>
          <span className={styles.specVal}>{data.nature}</span>
          <span className={styles.specSign}>г/л</span>
        </div>
      </div>
      <div className={styles.bottomData}>
        <span className={styles.title}>{title}</span>
        <span className={styles.price}>
          {Number(price)?.toLocaleString('RU-ru') || 0} ₽
        </span>
      </div>
    </div>
  );
};

interface IDataCardBadge {
  data: {
    gluten: number;
    idk: number;
    protein: number;
    humidity: number;
    cp: number;
    nature: number;
  };
  weight: number;
  id: string;
  title: string;
  price: number;
}
